/**
 * Create React App: PUBLIC_URL / package.json "homepage" prefix for non-root deploys.
 * Navigation must use the same prefix or the address bar and deep links break.
 */
export function getPublicBase() {
  const raw = process.env.PUBLIC_URL || "";
  if (!raw || raw === "/") return "";
  return raw.replace(/\/+$/, "");
}

export function stripPublicBase(pathname) {
  const base = getPublicBase();
  if (!base) return pathname;
  if (pathname === base || pathname === `${base}/`) return "/";
  if (pathname.startsWith(`${base}/`)) {
    const rest = pathname.slice(base.length);
    return rest || "/";
  }
  return pathname;
}

export function withPublicBase(logicalPath) {
  const base = getPublicBase();
  const p = logicalPath.startsWith("/") ? logicalPath : `/${logicalPath}`;
  if (!base) return p;
  return `${base}${p}`;
}

export function normalizeLogicalPath(pathname) {
  const raw = pathname || "/";
  return raw.replace(/\/+$/, "") || "/";
}

export function readLogicalPathname() {
  return normalizeLogicalPath(stripPublicBase(window.location.pathname));
}
